import { Link } from 'react-router-dom'
import SiteFooter from '../components/SiteFooter.jsx'

export default function NotFoundPage() {
  return (
    <>
      <main id="main-content">
        <section className="page-hero">
          <span className="eyebrow">404 · Page not found</span>
          <h1>
            This space is still <em>open</em>.
          </h1>
          <p>
            The page may have moved, or the address may be incomplete. The studio home and
            privacy library are ready to help you find the right place.
          </p>
          <div className="action-row back-row">
            <Link className="button button-primary" to="/">
              Go to Zpace Studio
            </Link>
            <Link className="button" to="/privacy/">
              Open the privacy library
            </Link>
          </div>
        </section>
      </main>

      <SiteFooter note="Thoughtful digital spaces, carefully connected." />
    </>
  )
}
